import { useCallback } from 'react'
import ProfileService from 'services/ProfileService'
import { useAppDispatch, useAppSelector } from 'state'
import { updateUserBonuses } from '../actions'

export const useUserBonus = () => {
  const dispatch = useAppDispatch()
  const bonuses = useAppSelector((state) => state.bonus.userBonuses)

  const fetchBonuses = useCallback(async () => {
    const result = await ProfileService.getUserData()

    if (result?.data?.userBonuses) {
      dispatch(
        updateUserBonuses({
          userBonuses: result.data.userBonuses,
        }),
      )
    }

    return {
      data: {
        items: result?.data?.userBonuses || [],
      },
    }
  }, [dispatch])

  return { bonuses: bonuses || [], fetchBonuses }
}
